const featureFlags = {
  autoCreateClassWhenFeaturedProgramIsPresent: false, // 1
  showVideoAfterAddingFirstClass: false,
  allowAnyoneToSkipBetweenLevels: true
};
Object.freeze(featureFlags);

/*
1) If we re-activate this feature we need to add updateProfile with gettingStartedOptIn=true after class auto-creation
*/

export default featureFlags;



// WEBPACK FOOTER //
// ./src/featureFlags.js